import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { useConcreteTestSetTrackerContext } from '../../ConcreteTestSetTrackerContext'
import Cores from './components/Cores'
import Material from './components/Material'
import Placements from './components/Placements'
import Tests from './components/Tests'
import { PayItemNoGeometry } from 'schema'
import { ConcreteTestSet } from '../../ConcreteTestSetTrackerContext/types'

export function useExpand(): ExpandOptions<ConcreteTestSet> {
  const { relations } = useConcreteTestSetTrackerContext()
  return {
    expandable: ({
      concretePlacements,
      concreteTests,
      payItemNoGeometries,
      concreteMaterial,
    }) =>
      !!concreteMaterial ||
      !!concretePlacements.length ||
      !!concreteTests.length ||
      !!payItemNoGeometries.length,
    render: (record) => {
      const { globalId, concretePlacements, concreteTests, concreteMaterial } =
        record
      const payItems = [
        ...record.payItemNoGeometries,
        ...concretePlacements.flatMap(
          ({ payItemNoGeometries }) => payItemNoGeometries
        ),
        ...concreteTests.flatMap(
          ({ payItemNoGeometries }) => payItemNoGeometries
        ),
      ].reduce((payItems, payItem) => {
        if (!payItems.some(({ globalId }) => globalId === payItem.globalId))
          payItems.push(payItem)
        return payItems
      }, Array<Pick<PayItemNoGeometry, '__typename' | 'globalId' | 'label' | 'deleted'>>())
      return {
        additionalInfo: [
          {
            type: 'default',
            label: 'Total Cubic Yards',
            children: concretePlacements.reduce(
              (total, { placementQtyVolCy }) =>
                total + (placementQtyVolCy ?? 0),
              0
            ),
          },
          { type: 'payItems', payItems, object: 'Concrete Test Set' },
        ],
        custom: [
          {
            label: 'Tests',
            children: <Tests {...record} />,
            hidden: !relations.loading && !concreteTests.length,
          },
          {
            label: 'Cores',
            children: <Cores {...record} />,
            hidden:
              !relations.loading &&
              !concretePlacements.some(
                ({ concreteCoreMeasurements }) =>
                  !!concreteCoreMeasurements.length
              ),
          },
          {
            label: 'Placements',
            children: <Placements {...record} />,
            hidden: !relations.loading && !concretePlacements.length,
          },
          {
            label: 'Material',
            hidden: !concreteMaterial,
            children: (
              <Material
                globalId={globalId}
                concreteMaterial={concreteMaterial}
              />
            ),
          },
        ],
      }
    },
  }
}
